export default __webpack_public_path__ + "static/media/27.af7b2fe2.png";